<template>
  <section class="page login">
    <div class="login__background">
      <img :src="$cdn + '/images/background-banner.jpg'" alt="background banner">
    </div>
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <div class="login__container">
            <div class="login__content">
              <div class="login__section">PROVEEDORES</div>
              <div class="login__main">
                <a href="https://cajasan.com" target="_blank" rel="noopener noreferrer" class="login__link">
                  <b-icon icon="house-door-fill"></b-icon>
                </a>
                <!--Por el momento no se hace el paso el RUT-->
                <formularioRut v-if="state == 'rut'" @stateChange='stateChange'/>
                <formularioRegistro v-if="state == 'register'" v-bind:datos-ini="datos" @stateChange='stateChange'/>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <footerCustom />
  </section>
</template>

<script>
import formularioRut from '@/components/forms/formRut.vue'
import formularioRegistro from '@/components/forms/formRegister.vue'
import footerCustom from '@/components/ui/footer.vue'

export default {
  name: 'loginRegister',
  data () {
    return {
      state: 'rut',
      datos: ''
    }
  },
  components: {
    formularioRut,
    formularioRegistro,
    footerCustom
  },
  methods: {
    stateChange: function (estado, datos) {
      console.log("Datos recibidos")
      console.log(datos)
      this.state = estado
      this.datos = datos
    }
  }
}
</script>
